import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/en";
import "dayjs/locale/de";
import "dayjs/locale/fr";
import { log } from "./common.logger";

dayjs.extend(localizedFormat);

/**
 * Handles null, undefined, or empty locale safely. *
 * Strips region ("en-US" → "en"). *
 * Checks if the date is valid before formatting. *
 * Catches any unexpected runtime errors. *
 * Always returns a string — never crashes the app.
 *
 * @param dateString if not profided show fallback character "-".
 * @param locale (used in TSX which sometimes can be null this is the reason for additional checks here).
 * @returns
 */
export const formatShortDate = (
  dateString: string | null | undefined,
  locale: string | null | undefined = "en"
): string => {
  try {
    if (!dateString) return "—";

    const safeLocale =
      typeof locale === "string" && locale.length > 0
        ? locale.split("-")[0]
        : "en";

    const date = dayjs(dateString);
    if (!date.isValid()) return "—";

    return date.locale(safeLocale).format("L");
  } catch (err) {
    log("formatShortDate exception:", err);
    return "—";
  }
};

// Convert timestamp to real date but return only numbers.
// Used by footer.verson.
export const timestampToCompactDateTime = (unixTimestamp: number | string): string => {
	const timestamp = typeof unixTimestamp === "string" ? parseInt(unixTimestamp, 10) : unixTimestamp;
	const date = new Date(timestamp * 1000); // convert seconds to milliseconds

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");

	return `${year}${month}${day}${hours}${minutes}`; //${seconds}
};

export function formatDateMMDDYYYY(dateString: string): string {
	const date = dayjs(dateString);
	return date.isValid() ? date.format("MM/DD/YYYY") : "";
}
